import React, { useState } from "react";
import { Button } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import EmojiPicker from "emoji-picker-react";

export default function EmojiPickerComponent({ onEmojiSelect }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="position-relative">
      <Button icon={<SmileOutlined />} onClick={() => setVisible((v) => !v)} />
      {visible && (
        <div
          className="position-absolute"
          style={{ bottom: "40px", zIndex: 999 }}
        >
          <EmojiPicker
            onEmojiClick={(emojiData) => {
              onEmojiSelect(emojiData.emoji);
              setVisible(false);
            }}
          />
        </div>
      )}
    </div>
  );
}
